import axios from './axiosConfig'; // Assuming you have a configured axios instance like in complianceActions

// Define API_URL (adjust if your asset API is different from compliance)
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";

// Action Types
export const GET_ASSETS = 'GET_ASSETS';
export const ADD_ASSET = 'ADD_ASSET';
export const EDIT_ASSET = 'EDIT_ASSET';
export const DELETE_ASSET = 'DELETE_ASSET';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const ASSETS_DATA = 'ASSETS_DATA';
export const SET_LOCATIONS = 'SET_LOCATIONS';

// Action Creators
export const getInventory = (departmentId = null) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_inventory`,
        {
          params: departmentId ? { department_id: departmentId } : {}
        }
      );

      dispatch({
        type: GET_ASSETS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to fetch assets"
      });
    }
  };
};


export const getInventoryComp = (compId = null) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_inventory`,
        {
          params: compId ? { compliance_id: compId } : {}
        }
      );

      dispatch({
        type: GET_ASSETS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to fetch assets"
      });
    }
  };
};

export const addAsset = (assetData) => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        try {
            // Use API_URL
            ////console.log("assetData ", assetData)
            const response = await axios.post(`${API_URL}/api/assets/add_asset`, assetData);
            dispatch({
                type: ADD_ASSET,
                payload: response.data
            });
            return response.data;
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to add asset'
            });
            throw error;
        }
    };
};

export const duplicateAsset = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });
    try {
      const response = await axios.post(`${API_URL}/api/assets/duplicate_asset/${id}`);

      

      return response.data;
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to duplicate asset"
      });
      throw error;
    }
  };
};


export const editAsset = (id, assetData) => {
  //console.log(assetData)
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        try {
            // Use API_URL
            const response = await axios.put(`${API_URL}/api/assets/edit_asset/${id}`, assetData);
            dispatch({
                type: EDIT_ASSET,
                payload: response.data
            });
            return response.data;
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to edit asset'
            });
            throw error;
        }
    };
};

// add dependency (draw mode)
export const addDependency = (assetId, dependsOnId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });
    try {
      const response = await axios.post(
        `${API_URL}/api/assets/${assetId}/dependencies`,
        { dependsOnId }
      );

      return response.data;
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to add dependency",
      });
      throw error;
    }
  };
};

// delete dependency (delete mode)
export const deleteDependency = (assetId, dependsOnId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });
    try {
      const response = await axios.delete(
        `${API_URL}/api/assets/${assetId}/dependencies`,
        { data: { dependsOnId } } // ✅ axios delete body
      );


      return response.data;
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to delete dependency",
      });
      throw error;
    }
  };
};


export const deleteAsset = (id) => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        ////console.log("ID ", id)
        try {
            await axios.delete(`${API_URL}/api/assets/delete_asset/${id.id}`);
            dispatch({
                type: DELETE_ASSET,
                payload: id
            });
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to delete asset'
            });
        }
    };
};


export const getAssetStats = (departmentId = null) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_asset_stats`,
        {
          params: departmentId ? { department_id: departmentId } : {}
        }
      );

      dispatch({
        type: ASSETS_DATA,
        payload: response.data
      });
    } catch (error) {
      console.error("Failed to fetch asset stats:", error);
    }
  };
};

export const getAssetStatsComp = (compId = null) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_asset_stats`,
        {
          params: compId ? { compliance_id: compId } : {}
        }
      );

      dispatch({
        type: ASSETS_DATA,
        payload: response.data
      });
    } catch (error) {
      console.error("Failed to fetch asset stats:", error);
    }
  };
};



export const getLocations = (departmentId) => {
    return async (dispatch) => {
        if (!departmentId) return;
        try {
            const response = await axios.get(`${API_URL}/api/assets/get_locations`, {
                params: { department_id: departmentId }
            });
            dispatch({ type: SET_LOCATIONS, payload: response.data });
        } catch (error) {
            dispatch({ type: SET_ERROR, payload: error.response?.data?.message || 'Failed to fetch locations' });
        }
    };
};

export const addLocation = (name, departmentId) => {
    return async (dispatch) => {
        if (!departmentId) return;
        try {
            const response = await axios.post(`${API_URL}/api/assets/add_location`, { name, department_id: departmentId });
            dispatch({ type: SET_LOCATIONS, payload: response.data });
        } catch (error) {
            dispatch({ type: SET_ERROR, payload: error.response?.data?.message || 'Failed to add location' });
        }
    };
};

export const deleteLocation = (id, departmentId) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API_URL}/api/assets/delete_location`, { id, department_id: departmentId });
            dispatch({ type: SET_LOCATIONS, payload: response.data });
        } catch (error) {
            dispatch({ type: SET_ERROR, payload: error.response?.data?.message || 'Failed to delete location' });
        }
    };
};

export const getUsers = () => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        try {
            const response = await axios.get(`${API_URL}/api/admin/get_users`);
            dispatch({
                type: SET_USERS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to fetch users'
            });
        }
    };
};